import {useMediaQuery} from '@mui/material'
import {FC, useContext, useEffect, useRef, useState} from 'react'
import {Link, useNavigate} from 'react-router-dom'
import {IconButton} from 'features/buttons'
import {GoogleContext, GoogleContextType, GoogleModal} from 'features/user'
import {scrollTo} from 'shared/lib/scroll-to'
import {img} from 'shared/mirrors/img'
import {text} from 'shared/mirrors/text'
import {Button} from 'shared/ui/buttons'
import {Checkbox} from 'shared/ui/checkbox'
import {HorizontalDivider} from 'shared/ui/dividers/horizontalDivider'
import {Google} from 'shared/ui/icons'
import styles from './styles.module.scss'
import {ChooseSex} from './ui'

const TERMS_ERROR_TEXT = 'Please accept our Terms Of Use, Privacy Policy and Community Rules'

export const CreateAccount: FC = () => {
  const {googleLogin} = useContext(GoogleContext) as GoogleContextType
  const [isAcceptedTerms, setIsAcceptedTerms] = useState<boolean>(false)
  const navigate = useNavigate()
  const [errorTerms, setErrorTerms] = useState<string>('')
  const errorRef = useRef<HTMLDivElement | null>(null)
  const is768p = useMediaQuery('(max-width: 767px)')

  useEffect(() => {
    if (!isAcceptedTerms && is768p) scrollTo(errorRef, 'center')
  }, [errorTerms])

  const hasTermsError = () => {
    setErrorTerms('')

    if (!isAcceptedTerms) {
      setErrorTerms(TERMS_ERROR_TEXT)
      if(is768p) scrollTo(errorRef, 'center')

      return true
    }

    return false
  }

  const onClickJoin = () => {
    if (!hasTermsError()) navigate('/register')
  }

  const onClickGoogle = () => {
    if (!hasTermsError()) googleLogin()
  }

  const onChangeTermsHandler = () => {
    setErrorTerms('')
    setIsAcceptedTerms(!isAcceptedTerms)
  }

  return (
    <div className={styles.container}>
      <GoogleModal />
      <div className={styles.content}>
        <div className={styles.logoContainer}>
          <img width={40} src={img.logo} alt='logo' />
          <h3 className={styles.logoContainer__name}>{text.main.siteName}</h3>
        </div>
        <div className={styles.titleContainer}>
          <h4 className={styles.createAccount}>Create account</h4>
          <p className={styles.createAccount__caption}>
            Join the space where you can meet anyone everywhere!
          </p>
        </div>
        <div className={styles.sexChooseContainer}>
          <ChooseSex onlyOne text='I am' />
          <ChooseSex text='Seeking' />
        </div>

        <Button
          className={styles.joinBtn}
          fullwidth
          as='button'
          styleType='primary'
          onClick={onClickJoin}
        >
          Create account
        </Button>

        <HorizontalDivider>or continue with</HorizontalDivider>
        <IconButton
          fullwidth
          alt='google-svg'
          styleType='secondary'
          icon={<Google />}
          onClick={onClickGoogle}
          className={styles.signInBtn}
        >
          Google
        </IconButton>
        <div className={styles.modalTerms} onClick={onChangeTermsHandler}>
          <div className={styles.modalTermsCheck}>
            <Checkbox
              color='primary'
              checked={isAcceptedTerms}
              onChange={onChangeTermsHandler}
            />
            <div>
              I have read, understand and agree to {' '}
              <Link className={styles.modalTermsLink} to='/terms-of-use'>
                Terms of Use
              </Link>
              ,{' '}
              <Link className={styles.modalTermsLink} to='/privacy-policy'>
                Privacy Policy
              </Link>{' '}
              &{' '}
              <Link className={styles.modalTermsLink} to='/community-rules'>
                Community Rules
              </Link>
            </div>
          </div>
          {errorTerms ?
            <p className={styles.modalTermsError} ref={errorRef}>{errorTerms}</p>
            : null}
        </div>
        {/*<IconButton
          fullwidth
          alt='facebook-svg'
          icon={facebookIcon}
          styleType='secondary'
        >
          Sign in with Facebook
        </IconButton>*/}
      </div>
    </div>
  )
}
